// Tour Planner — plan editor route.
// -----------------------------------------------------------------
// Per docs/architecture/m4-tour-planner-plan.md § 3 M4.1 + dispatch
// docs/architecture/dispatches/m4-1-plan-list-editor-shell.md § 6.8.
//
// TanStack Router file-system convention: the `$planId` segment is
// the dynamic param. The trailing-underscore filename
// `tour-planner_.$planId.tsx` is the "flatten / opt out of nesting"
// convention — this route is a SIBLING of `/tour-planner` (both
// children of `/_authenticated`), not a child. The URL stays
// `/tour-planner/$planId` either way; the difference is whether
// the parent `/tour-planner` has to render `<Outlet />` to expose
// the child. Per M4-F11 (M4.1-P1 lead-direct verification 2026-05-08):
// the original `tour-planner.$planId.tsx` filename produced a
// parent-child route tree, and the parent's body rendered
// <PlanList> + <CreatePlanForm> with no <Outlet />, so navigating
// to /tour-planner/<id> updated the URL but never mounted this
// component. The trailing-underscore rename is the surgical fix —
// no <Outlet /> needed in the parent, both routes mount cleanly.
// tsr generate emits the route into src/routeTree.gen.ts on every
// typecheck/lint/test.
//
// Per dispatch § 3.5 + M4-F6: the editor shell is plan-level only
// in M4.1; no cross-collection reads. M4.3 lands the track list
// (which DOES cross-collection-read into tours_staging).

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { PlanEditorShell } from '@/components/tour-planner/PlanEditorShell';
import { isFeatureEnabled } from '@/lib/featureFlags';

const TourPlannerPlanIdRoute = () => {
  const { planId } = Route.useParams();
  if (!isFeatureEnabled('TOUR_PLANNER')) {
    return <Navigate to='/hello' replace />;
  }
  return <PlanEditorShell planId={planId} />;
};

export const Route = createFileRoute('/_authenticated/tour-planner_/$planId')({
  component: TourPlannerPlanIdRoute,
});
